// Where a Back button goes.
//
// Settings' Back used to be navigate(-1), which is "wherever you were", not
// "where this page belongs". Those are the same thing right up until two pages
// link to each other. Settings links out to Safety; Safety's Back returns to
// Settings; so a history-relative Back from Settings landed on Safety, and
// Safety sent the viewer straight back. Two pages, no exit but the browser's
// own controls.
//
// The rule instead: a Back button climbs to the page it belongs to. History is
// left to the browser's back button, which is the control that actually means
// "wherever you were".

/** The page a settings-like screen returns to when nothing says otherwise. */
export const PROFILE_HOME = '/profile/view';

export interface NavigationOrigin {
  /**
   * Where this screen was opened from.
   *
   * Only openers that are NOT the parent set this — the swipe deck's "Adjust
   * who you see", for instance, because the viewer was never on the profile
   * page and returning them there would be a non-sequitur.
   *
   * Pages that are children of Settings must never set it. Safety navigating
   * here with `from: '/safety'` would rebuild the exact loop this replaced.
   */
  from?: string;
}

/**
 * Resolves a Back destination from router state.
 *
 * @param state    location.state, whatever the router happens to hold.
 * @param fallback The page this screen belongs to.
 */
export function backDestination(state: unknown, fallback: string = PROFILE_HOME): string {
  const from = (state as NavigationOrigin | null | undefined)?.from;
  return typeof from === 'string' && from.length > 0 ? from : fallback;
}
